const FAQ = [
  {
    question: "What types of gadgets do you sell?",
    answer:
      "We offer a wide range of electronics, including smartphones, accessories, audio devices, gaming gadgets, wearables, and more.",
  },
  {
    question: "What is your return policy?",
    answer:
      "Our return policy allows returns within 15 days of purchase, provided the product is unused, in its original packaging, and with all accessories.",
  },
  {
    question: "How can I track my order?",
    answer:
      "You can track your order using the tracking link in your confirmation email or by visiting our website and entering your order number.",
  },
  {
    question: "Do you offer international shipping?",
    answer:
      "Yes, we provide international shipping to select countries. Shipping charges and delivery times vary based on the destination.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept major credit/debit cards, UPI, Net Banking, PayPal, and EMI options on select products.",
  },
  {
    question: "How do I contact customer support?",
    answer:
      "You can contact our support team via email at support@yourstore.com or call us at 1-800-123-4567 during business hours.",
  },
  {
    question: "Can I cancel or modify my order after placing it?",
    answer:
      "Orders can only be modified or canceled before they are processed for shipping. Contact us as soon as possible for any changes.",
  },
  {
    question: "What should I do if I receive a defective product?",
    answer:
      "If you receive a defective or damaged product, contact us within 48 hours with your order details and a photo of the issue for a replacement or refund.",
  },
  {
    question: "Do you offer warranties on products?",
    answer:
      "Yes, most of our products come with a manufacturer’s warranty. Warranty details can be found on the product page or in the packaging.",
  },
  {
    question: "Do you have a loyalty or rewards program?",
    answer:
      "Yes! Our loyalty program allows you to earn points for every purchase, which can be redeemed for discounts on future orders.",
  },
];

export default FAQ;
